export default {
  mapping: {},
  serialized: '',
  topicFamilies: [],
  commandTopic: null,
  mqttConnected: false,
  localAccess: [],
  commandHistory: [],
  feedbackHistory: []
};